<template>
  <div class="prodfile-list">
    <Toolbar :handle-add="() => addHandlerSub('ProdFile',parentAdd)" v-if="userHasAccess('prodfile_edit')">
      <template #left>
        <h1><v-icon large>mdi-file-powerpoint</v-icon>{{$t('prodfile.prodfiles')}}</h1>
      </template>
    </Toolbar>
    <v-container >
      <v-layout row wrap>
        <v-flex lg12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
            @update:options="onUpdateOptions"
          >
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProdFileList',
  servicePrefix: 'ProdFile',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
  },
  props: {
    designFileParent: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('machine.machine'), value: 'machine.name' },
        { text: this.$t('tool.tool'), value: 'tool.name' },
        { text: this.$t('material.material'), value: 'material.name' },


      ],
  selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]},
      filters: {
        'designFile' : this.designFileParent['@id'],
      },
      parentAdd: {
        '@id' : this.designFileParent['@id'],
      }
    };
  },
  computed: {
    ...mapGetters('prodfile', {
      items: 'list'
    }),
    ...mapFields('prodfile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('prodfile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
